export const settingsGUI = {
  computed: {
    coordinateOrderLonLat: function () {
      return this.$store.getters.getUserSetting('ui.common.coordinateOrder', 'lonlat') === 'lonlat'
    }
  },
  methods: {
    formatCoords: function (coords) {
      if (coords) {
        return formatCoords(coords, this.coordinateOrderLonLat)
      } else {
        return 'Нет данных'
      }
    }
  }
}

export function formatCoords (coords, coordinateOrderLonLat) {
  if (typeof coords === 'string') {
    // без пользовательской настройки
    return coords
  } else if (Array.isArray(coords)) {
    if (coordinateOrderLonLat) {
      return formatCoord(coords[0]) + ', ' + formatCoord(coords[1])
    } else {
      return formatCoord(coords[1]) + ', ' + formatCoord(coords[0])
    }
  } else if (typeof coords === 'object') {
    if (coordinateOrderLonLat) {
      return formatCoord(coords.lon) + ', ' + formatCoord(coords.lat)
    } else {
      return formatCoord(coords.lat) + ', ' + formatCoord(coords.lon)
    }
  } else {
    // без пользовательской настройки
    return coords.toString()
  }
}

function formatCoord (coord) {
  if (coord == null) {
    return ''
  }
  return coord.toFixed(6)
}
